var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSessionActionRequired = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28.2001,
    r: 28,
    fill: "#BF1722"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28.2001,
    r: 22,
    fill: "#BF1722"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.2001,
    r: 16,
    fill: "#BF1722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 34.7001L28 19.3251L37 34.7001H19ZM21.8227 33.0817H34.1773L28 22.5619L21.8227 33.0817ZM28 32.2724C28.2318 32.2724 28.4261 32.1949 28.583 32.0398C28.7398 31.8847 28.8182 31.6925 28.8182 31.4632C28.8182 31.234 28.7398 31.0418 28.583 30.8867C28.4261 30.7316 28.2318 30.654 28 30.654C27.7682 30.654 27.5739 30.7316 27.417 30.8867C27.2602 31.0418 27.1818 31.234 27.1818 31.4632C27.1818 31.6925 27.2602 31.8847 27.417 32.0398C27.5739 32.1949 27.7682 32.2724 28 32.2724ZM27.1818 29.8448H28.8182V25.7988H27.1818V29.8448Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSessionActionRequired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/session-action-required.2904ec3ebf1b7ce0eb4b0b43e5103f16.svg";